<template>
  <div v-if="asyncDataStatus_ready" class="col-full push-top">
    <h2>
      {{ companyTypeName === 'Distributors' ? 'Nov distributer' : 'Nova stranka' }}:
    </h2>

    <ClientsFormNew
      :companyType="companyType"
      @save="save"
      @cancel="cancel"
      ref="form"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ClientsFormNew from '@/components/ClientsFormNew'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  components: {
    ClientsFormNew
  },
  mixins: [
    asyncDataStatus
  ],
  props: {
    companyType: {
      required: true,
      type: Number
    },
    companyTypeName: {
      required: true,
      type: String
    }
  },
  methods: {
    ...mapActions('companies', ['createCompany']),
    save ({ data, repeat = false }) {
      this.createCompany(data)
        .then(company => {
          /* this.$notify({
            type: 'success',
            text: 'Podatki so bili uspešno shranjeni.'
          }) */
          if (!repeat) {
            this.$router.push({ name: this.companyTypeName })
          } else {
            this.$refs.form.clearForm()
          }
        })
    },
    cancel () {
      this.$router.push({ name: this.companyTypeName })
    }
  },
  created () {
    this.asyncDataStatus_fetched()
  }
}
</script>
